import { useState, useCallback } from 'react';

export const useConfirmationModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedAnswerText, setSelectedAnswerText] = useState('');
  const [onConfirmCallback, setOnConfirmCallback] = useState<(() => void) | null>(null);

  const showConfirmation = useCallback((answerText: string, onConfirm: () => void) => {
    setSelectedAnswerText(answerText);
    setOnConfirmCallback(() => onConfirm);
    setIsOpen(true);
  }, []);

  const handleConfirm = useCallback(() => {
    if (onConfirmCallback) {
      onConfirmCallback();
    }
    setIsOpen(false);
    setSelectedAnswerText('');
    setOnConfirmCallback(null);
  }, [onConfirmCallback]);

  const handleCancel = useCallback(() => {
    setIsOpen(false);
    setSelectedAnswerText('');
    setOnConfirmCallback(null);
  }, []);

  return {
    isOpen,
    selectedAnswerText,
    showConfirmation,
    handleConfirm,
    handleCancel,
  };
};
